import { COMMON_EMAIL_DOMAINS } from '../../email-domains/email-domains';

export function getEmailSuggestion(email: string): string | null {
  if (!email || !email.includes('@')) return null;

  const [localPart, domainPartRaw] = email.split('@');
  if (!domainPartRaw) return null;

  const domainPart = domainPartRaw.toLowerCase();

  const prefixMatch = COMMON_EMAIL_DOMAINS.find(d => d.startsWith(domainPart));
  if (prefixMatch && prefixMatch !== domainPart) {
    return `${localPart}@${prefixMatch}`;
  }

  let closestDomain = '';
  let minDistance = Infinity;

  for (const d of COMMON_EMAIL_DOMAINS) {
    const dist = levenshtein(domainPart, d);
    if (dist < minDistance) {
      minDistance = dist;
      closestDomain = d;
    }
  }

  if (minDistance > 0 && minDistance <= 2 && closestDomain !== domainPart) {
    return `${localPart}@${closestDomain}`;
  }

  return null;
}

export function levenshtein(a: string, b: string): number {
  const matrix = [];

  for (let i = 0; i <= b.length; i++) matrix[i] = [i];
  for (let j = 0; j <= a.length; j++) matrix[0][j] = j;

  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          Math.min(matrix[i][j - 1] + 1, matrix[i - 1][j] + 1)
        );
      }
    }
  }

  return matrix[b.length][a.length];
}
